module.exports = __webpack_public_path__ + "img/IMG_9593.76267514.jpg";